import { Cart } from '../cart/cart';

const cart = new Cart();

/**
 * Add items to cart
 * @param  {jQ Obj} $this The element, which fired the event
 * @return {Void}
 */
export const addItems = ($this) => {
  const items = [];
  const $form = $this.closest('form');
  const id = $this
    .closest('form')
    .find('[name="id"]')
    .val();
  const quantity = $this.closest('form').find('[name="quantity"]').val();

  items.push({ id, quantity });

  cart.addSecondary($form);
}

$(document).on('click', '.js-ajax-add', function(event) {
  event.preventDefault();

  $(this).addClass('btn--loading');

  addItems($(this));
});

$(document).on('click', '.js-cross-sell-add', function(event) {
  event.preventDefault();
  
  const $this = $(this);
  const items = [];
  const id = $this.attr('href').split('id=')[1].split('&quantity')[0];
  const quantity = $this.attr('href').split('&quantity=')[1];

  items.push({ id, quantity });
  cart.add(items);
});

// Remove
$(document).on('click', '.js-remove', function(event) {
  event.preventDefault();

  const $this = $(this);
  const line = $this.data('line');
  const $product = $this.closest('.js-table-product');

  $product.slideUp();
  cart.removeItem(line)
});

// Change
$(document).on('change', '.js-quantity', function(event) {
  event.preventDefault();

  const $this = $(this);
  const id = $this.attr('data-variant-id');
  const quantity = $this.val();
  const $holder = $this.closest('.js-cart-items-holder');

  $holder.addClass('is-busy');
  cart.updateItem(quantity, id);
});
